import React, { lazy } from 'react';

import { Navigate } from 'react-router-dom';

import { CREATE_SERVICE_ROUTE, EDIT_SERVICE_ROUTE, MY_SERVICES_ROUTE } from './services/list';

import { RouteType } from 'types/core/routeTypes';

import AdminRoleGuard from '../component/admin-role-guard';
import { ADMIN_USERS_ROUTE } from './admin/list';
import { CALENDAR_ROUTE, OUTLETS_ROUTE, SELLERS_ROUTE } from './core/list';
import { ABOUT_ROUTE, DASHBOARD_ROUTE, FAQ_ROUTE, PRICING_ROUTE } from './dashboard/list';
import { FEATURE_ROUTE } from './help/list';
import {
  CREATE_DEVELOPMENT_FORM_ROUTE,
  CREATE_PROPERTY_FORM_ROUTE,
  DEVELOPMENT_DETAIL_ROUTE,
  EDIT_DEVELOPMENT_FORM_ROUTE,
  EDIT_PROPERTY_FORM_ROUTE,
  PROPERTY_DETAIL_ROUTE,
} from './property/list';
import { TICKETS_SCANS_ROUTE } from './tikets/list';
import {
  AGENCY_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  INVITE_REGISTER_ROUTE,
  LOGIN_ROUTE,
  PROFILE_ROUTE,
  RECONFIRM_ROUTE,
  REDIRECT_ROUTE,
  REGISTER_ROUTE,
  RESET_PASSWORD_ROUTE,
} from './user-management/list';
import { LANDING_ROUTE } from './user-management/list';

const Services = lazy(() => import('pages/services'));

const About = lazy(() => import('pages/about'));
const AdminUserList = lazy(() =>
  import('pages/admin-pages').then((m) => ({ default: m.AdminUserList })),
);
const Agency = lazy(() => import('pages/agency/agency'));
const Calendar = lazy(() => import('pages/calendar'));
const CreateDevelopment = lazy(() => import('pages/createDevelopment'));
const Developer = lazy(() => import('pages/developer'));
const FAQ = lazy(() => import('pages/faq'));
const Features = lazy(() => import('pages/features'));
const Landing = lazy(() => import('pages/landing'));
const Outlets = lazy(() => import('pages/outlets'));
const PostProperty = lazy(() => import('pages/postProperty'));
const Pricing = lazy(() => import('pages/pricing/pricing'));
const Profile = lazy(() => import('pages/profile'));
const CreateService = lazy(() => import('pages/profile/contacts/createService'));
const PropertyDetail = lazy(() => import('pages/propertyDetail'));
const Redirect = lazy(() => import('pages/redirect'));
const ScanPage = lazy(() => import('pages/scan-page'));
const Sellers = lazy(() => import('pages/sellers'));
const Dashboard = lazy(() => import('pages/user-management/dashboard'));
const ForgotPassword = lazy(() => import('pages/user-management/forgot-password'));
const Login = lazy(() => import('pages/user-management/login'));
const Register = lazy(() => import('pages/user-management/register'));
const ResetPassword = lazy(() => import('pages/user-management/reset-password'));

export const HOME_NON_AUTH_ROUTE = LOGIN_ROUTE;
export const UNKNOWN_ROUTE = '*';

export const AUTH_ROUTES: RouteType[] = [
  { path: CALENDAR_ROUTE, element: <Calendar /> },
  { path: TICKETS_SCANS_ROUTE, element: <ScanPage /> },
  { path: OUTLETS_ROUTE, element: <Outlets /> },
  { path: SELLERS_ROUTE, element: <Sellers /> },
  {
    path: ADMIN_USERS_ROUTE,
    element: (
      <AdminRoleGuard>
        <AdminUserList />
      </AdminRoleGuard>
    ),
  },
  { path: FEATURE_ROUTE, element: <Features /> },

  { path: CREATE_PROPERTY_FORM_ROUTE, element: <PostProperty /> },
  { path: EDIT_PROPERTY_FORM_ROUTE, element: <PostProperty /> },
  { path: CREATE_DEVELOPMENT_FORM_ROUTE, element: <CreateDevelopment /> },
  { path: EDIT_DEVELOPMENT_FORM_ROUTE, element: <CreateDevelopment /> },
  { path: DEVELOPMENT_DETAIL_ROUTE, element: <Developer /> },
  { path: PROPERTY_DETAIL_ROUTE, element: <PropertyDetail /> },
  { path: FAQ_ROUTE, element: <FAQ /> },
  { path: ABOUT_ROUTE, element: <About /> },
  { path: PRICING_ROUTE, element: <Pricing /> },
  { path: MY_SERVICES_ROUTE, element: <Services /> },
  { path: CREATE_SERVICE_ROUTE, element: <CreateService /> },
  { path: EDIT_SERVICE_ROUTE, element: <CreateService /> },
  { path: LANDING_ROUTE, element: <Landing /> },
  { path: AGENCY_ROUTE, element: <Agency /> },
  { path: PROFILE_ROUTE, element: <Profile /> },
  { path: UNKNOWN_ROUTE, element: <Navigate to={LANDING_ROUTE} /> },
];

export const NON_AUTH_ROUTES: RouteType[] = [
  { path: DASHBOARD_ROUTE, element: <Dashboard /> },
  { path: PROPERTY_DETAIL_ROUTE, element: <PropertyDetail /> },
  { path: DEVELOPMENT_DETAIL_ROUTE, element: <Developer /> },
  { path: FAQ_ROUTE, element: <FAQ /> },
  { path: AGENCY_ROUTE, element: <Agency /> },
  { path: RECONFIRM_ROUTE, element: <Register /> },
  { path: ABOUT_ROUTE, element: <About /> },
  { path: PRICING_ROUTE, element: <Pricing /> },
  { path: LANDING_ROUTE, element: <Landing /> },
  { path: MY_SERVICES_ROUTE, element: <Services /> },
  { path: LOGIN_ROUTE, element: <Login /> },
  { path: REGISTER_ROUTE, element: <Register /> },
  { path: INVITE_REGISTER_ROUTE, element: <Register /> },
  { path: FORGOT_PASSWORD_ROUTE, element: <ForgotPassword /> },
  { path: RESET_PASSWORD_ROUTE, element: <ResetPassword /> },
  { path: REDIRECT_ROUTE, element: <Redirect /> },
  { path: UNKNOWN_ROUTE, element: <Navigate replace to={LANDING_ROUTE} /> },
];
